import { ECertifikatAktivita } from 'enums/isin/udaje/certifikatAktivita';

const certifikatAktivitaAltSelect = [
    {
        value: ECertifikatAktivita.K,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_K'
    },
    {
        value: ECertifikatAktivita.A,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_A'
    },
    {
        value: ECertifikatAktivita.DN,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_DNUS'
    },
    {
        value: ECertifikatAktivita.KM,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_KOM'
    },
    {
        value: ECertifikatAktivita.M,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_M'
    },
    {
        value: ECertifikatAktivita.I,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_I'
    },
    {
        value: ECertifikatAktivita.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_AKTIVA_P_O'
    }
];

export default certifikatAktivitaAltSelect;
